export default "__VITE_ASSET__DNt9p87M__"